import _ from 'lodash';
import { offerAppliesToProduct } from '../../../../utils/marketingCampaign';
import { MarketingCampaignType, Offer } from '../../../../1_types/genericTypes';
import { addProductPrefix, isStringNotNull } from '../../../../utils';

export const preventPageBadEffect = () => {
  document.body.setAttribute('style', 'padding: 0px !i  mportant;');
  document
    .getElementById('sticky-cart')
    .setAttribute('style', 'padding: 0px !important;');
};

export const getActiveOptions = (
  productCategories: any,
  shopCategories: any,
): any[] => {
  if (!productCategories) return [];
  const categories = new Set();
  productCategories?.split(',')?.forEach((category) => {
    const categoryKey = category?.split('@')[0];
    if (shopCategories[categoryKey]) {
      categories.add(category);
    }
  });
  return Array.from(categories);
};

export const getCurrentOfferForProduct = (
  productKey: string,
  sectionKey: string,
  thresholdOffer: Offer,
  productOffers: Offer[],
  isOfferSection: boolean,
): Offer => {
  if (!isOfferSection) {
    return null;
  }
  if (
    thresholdOffer &&
    offerAppliesToProduct(thresholdOffer, productKey, sectionKey)
  ) {
    return thresholdOffer;
  }

  const currentOffer =
    _.find(productOffers, (productOffer) => {
      return (
        offerAppliesToProduct(productOffer, productKey, sectionKey) ||
        productKey === addProductPrefix(productOffer.key)
      );
    }) ?? null;

  if (
    currentOffer &&
    [
      MarketingCampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT,
      MarketingCampaignType.BUY_ONE_GET_ONE_PRODUCT,
    ].includes(currentOffer.type) &&
    !isOfferSection
  ) {
    return null;
  }

  return currentOffer;
};

export const getOfferProductsNbInPendingOrderBasket = (
  pendingOrderBasket: any,
  offerKey: string,
): number => {
  if (!isStringNotNull(offerKey)) {
    return 0;
  }
  return Object.values(pendingOrderBasket || {})
    .filter(
      (basketItem: any) => basketItem?.productMarketingCampaignKey === offerKey,
    )
    .reduce(
      (sum: number, basketItem: { nb?: number }) => sum + (basketItem?.nb ?? 1),
      0,
    ) as number;
};
